export type ContractStatus = "ACTIVE" | "INACTIVE";

export type Contract = {
  id: string;
  from: string;
  to: string;
  status: ContractStatus;
  loa: string;
  bf: string;
  signed: string;
  windowStart: string;
  windowEnd: string;
  supplyPeriod: number;
  returnPeriod: number;
  returnWindowStart: string;
  returnWindowEnd: string;
  returnTimeWindow: string;
  returnDays: number;
  returnHoursPerDay: number;
  returnBasis: "Firm" | "Non-firm";
};

export type SupplyPoint = {
  date: string;
  scheduled: number;
  actual: number;
  secondaryDate?: string;
};

export type PeriodRow = {
  date: string;
  scheduled: number;
  actual: number;
  delta: number;
  pct: number;
};

export const TOP_TABS = ["Active", "Inactive"] as const;
export const DETAIL_TABS = ["Overview","Documents"] as const;
export const GRANULARITY = ["Time Block", "Day", "Week", "Month"] as const;

export type TopTab = (typeof TOP_TABS)[number];
export type DetailTab = (typeof DETAIL_TABS)[number];
export type Granularity = (typeof GRANULARITY)[number];
